import React, { ReactNode, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { AppProductType } from 'types';
import { randomFromRange } from 'utils';
import { useSampleData } from './hooks';

interface SampleStationProps {
  productType: AppProductType;
  children: ReactNode;
}

const SampleStationsController = ({
  children,
  productType,
}: SampleStationProps) => {
  const { osceMarksheetId: osceMarksheetIdFromParams } = useParams<{
    osceMarksheetId: string;
  }>();
  const { osceMarksheets } = useSampleData(
    productType,
    Boolean(osceMarksheetIdFromParams)
  );
  const navigate = useNavigate();

  const osceMarksheetId = useMemo(() => {
    if (osceMarksheetIdFromParams) {
      return osceMarksheetIdFromParams;
    }

    const index = osceMarksheets
      ? randomFromRange(0, osceMarksheets.length - 1)
      : undefined;
    const marksheetData =
      typeof index === 'number' ? osceMarksheets?.[index] : undefined;

    return marksheetData ? Number(marksheetData.id) : undefined;
  }, [osceMarksheets, osceMarksheetIdFromParams]);

  useEffect(() => {
    if (osceMarksheetId) {
      navigate(`/sample/${productType}/stations/solo/study/${osceMarksheetId}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [osceMarksheetId, productType]);

  return <>{children}</>;
};

export default SampleStationsController;
